import { useContext } from "react";
import HomeLanding from "../components/HomeLanding";
import UserContext from "../context/UserContext";
import AdminLanding from "../components/AdminLanding";

function Home() {
  const { user } = useContext(UserContext);
  return <>{user && user.isAdmin ? <AdminLanding /> : <HomeLanding />}</>;
}

export default Home;
